<!-- searchbysize Modal body -->
<div class="modal-dialog" role="document">
<div class="modal-content">
  <div class="modal-header border-0">
    <h5 class="modal-title" id="exampleModalLabel">Search by Size</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="searchSizeForm" (ngSubmit)="onSubmitSizeSearchForm()">
    <div class="modal-body border-0">
      <h6>Front Wheel</h6>

      <div class="grid-row-box">
        <div class="form-group">
          <select class="form-control search-inputs" id="sel1" formControlName="front_rim_diameter">
            <option value="">1 &nbsp;|&nbsp; Diameters</option>
            <ng-template ngFor [ngForOf]="formDropdownValues?.diameter" let-item>
              <option *ngIf="item.name" [value]="item.name">{{ item.name}}</option>
            </ng-template>
          </select>
          <i class="fa fa-sort-desc"></i>
          <div
            *ngIf="searchSizeForm.get('front_rim_diameter').touched || searchSizeForm.get('front_rim_diameter').dirty">
            <span class="error" *ngIf="searchSizeForm.get('front_rim_diameter').hasError('required')">This field is
              required</span>
          </div>
        </div>

        <div class="form-group">
          <select class="form-control search-inputs" id="sel1" formControlName="front_rim_width">
            <option value="">2 &nbsp;|&nbsp; Width</option>
            <ng-template ngFor [ngForOf]="formDropdownValues?.width" let-item>
              <option *ngIf="item.name" [value]="item.name">{{ item.name}}</option>
            </ng-template>
          </select>
          <i class="fa fa-sort-desc"></i>
          <div *ngIf="searchSizeForm.get('front_rim_width').touched || searchSizeForm.get('front_rim_width').dirty">
            <span class="error" *ngIf="searchSizeForm.get('front_rim_width').hasError('required')">This field is
              required</span>
          </div>
        </div>

        <div class="form-group">
          <select class="form-control search-inputs" id="sel1" formControlName="front_bolt_pattern">
            <option value="">3 &nbsp;|&nbsp; Bolt Pattern</option>
            <ng-template ngFor [ngForOf]="formDropdownValues?.bolt_pattern" let-item>
              <option *ngIf="item.name" [value]="item.name">{{ item.name}}</option>
            </ng-template>
          </select>
          <i class="fa fa-sort-desc"></i>
          <div
            *ngIf="searchSizeForm.get('front_bolt_pattern').touched || searchSizeForm.get('front_bolt_pattern').dirty">
            <span class="error" *ngIf="searchSizeForm.get('front_bolt_pattern').hasError('required')">This field is
              required</span>
          </div>
        </div>

        <div class="form-group">
          <input type="text" formControlName="min_offset" class="form-control search-inputs"
            placeholder="4  |  Min Offset" />
          <div *ngIf="searchSizeForm.get('min_offset').touched || searchSizeForm.get('min_offset').dirty">
            <span class="error" *ngIf="searchSizeForm.get('min_offset').hasError('required')">This field is
              required</span>
          </div>
        </div>

        <div class="form-group">
          <input type="text" formControlName="max_offset" class="form-control search-inputs"
            placeholder="5  |  Max Offset" />
          <div *ngIf="searchSizeForm.get('max_offset').touched || searchSizeForm.get('max_offset').dirty">
            <span class="error" *ngIf="searchSizeForm.get('max_offset').hasError('required')">This field is
              required</span>
          </div>
        </div>
      </div>

      <!-- <h6 class="mt-4"><i class="fa fa-plus-circle pr-2" aria-hidden="true"></i>Add different rear wheel size</h6> -->

      <h6 class="mt-4">
        <a (click)="showRearSizeFields = true; onAddRearOptions(true)" *ngIf="!showRearSizeFields"><i
            class="fa fa-plus-circle pr-2" aria-hidden="true"></i>Add different rear wheel size?</a>
        <a (click)="showRearSizeFields = false;  onAddRearOptions(false)" *ngIf="showRearSizeFields"><i
            class="fa fa-minus-circle pr-2" aria-hidden="true"></i>Hide rear wheel size</a>

      </h6>

      <div class="" id="show-div-details" *ngIf="showRearSizeFields">
        <h6>Rear Wheel</h6>

        <div class="grid-row-box">
          <div class="form-group">
            <select class="form-control search-inputs" id="sel1" formControlName="rear_rim_diameter">
              <option value="">1 &nbsp;|&nbsp; Diameters</option>
              <ng-template ngFor [ngForOf]="formDropdownValues?.diameter" let-item>
                <option *ngIf="item.name" [value]="item.name">{{ item.name}}</option>
              </ng-template>
            </select>
            <i class="fa fa-sort-desc"></i>
            <div
              *ngIf="searchSizeForm.get('rear_rim_diameter').touched || searchSizeForm.get('rear_rim_diameter').dirty">
              <span class="error" *ngIf="searchSizeForm.get('rear_rim_diameter').hasError('required')">This field is
                required</span>
            </div>
          </div>

          <div class="form-group">
            <select class="form-control search-inputs" id="sel1" formControlName="rear_rim_width">
              <option value="">2 &nbsp;|&nbsp; Width</option>
              <ng-template ngFor [ngForOf]="formDropdownValues?.width" let-item>
                <option *ngIf="item.name" [value]="item.name">{{ item.name}}</option>
              </ng-template>
            </select>
            <i class="fa fa-sort-desc"></i>
            <div *ngIf="searchSizeForm.get('rear_rim_width').touched || searchSizeForm.get('rear_rim_width').dirty">
              <span class="error" *ngIf="searchSizeForm.get('rear_rim_width').hasError('required')">This field is
                required</span>
            </div>
          </div>



          <div class="form-group">
            <input type="text" formControlName="rear_min_offset" class="form-control search-inputs"
              placeholder="3  |  Min Offset" />
            <div
              *ngIf="searchSizeForm.get('rear_min_offset').touched || searchSizeForm.get('rear_min_offset').dirty">
              <span class="error" *ngIf="searchSizeForm.get('rear_min_offset').hasError('required')">This field is
                required</span>
            </div>
          </div>

          <div class="form-group">

            <input type="text" formControlName="rear_max_offset" class="form-control search-inputs"
              placeholder="4  |  Max Offset" />
            <div
              *ngIf="searchSizeForm.get('rear_max_offset').touched || searchSizeForm.get('rear_max_offset').dirty">
              <span class="error" *ngIf="searchSizeForm.get('rear_max_offset').hasError('required')">This field is
                required</span>
            </div>
          </div>


        </div>
      </div>
    </div>
    <div class="modal-footer border-0">
      <button type="submit" class="btn btn-02 f-large addcart new-btn bg-black w-auto go-btn-pad" [disabled]="isLoading">
        <app-preloader *ngIf="isLoading"></app-preloader>
        <span *ngIf="!isLoading">Go</span>
      </button>
    </div>

  </form>

</div>
</div>
